import React, { useState, useEffect, useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "../Style/Navbar.css";
import logo from "../Images/Logo.png";
import { Link, useNavigate } from "react-router-dom";

function Navbar() {
  const [navColor, setNavColor] = useState(false);
  const navRef = useRef();
  const history = useNavigate(); // Use history for navigation

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  const handleSelect = (event) => {
    const selectedTeam = event.target.value;
    if (selectedTeam) {
      history.push(`/${selectedTeam}`);
    }
  };

  const handleScheduleClick = (e) => {
    e.preventDefault();
    const scroll = () =>
      document.getElementById("schedule")?.scrollIntoView({ behavior: "smooth" });
    if (window.location.pathname === "/") {
      scroll();
    } else {
      history("/");
      setTimeout(scroll, 300);
    }
  };

  return (
    <header className={navColor ? "active" : ""}>
      <Link className="imageLink" smooth to="/#">
        <img src={logo} alt="logo" />
      </Link>
      <nav ref={navRef}>
        <Link className="Link" to="/">
          Home
        </Link>
        <div className="dropdown">
          <button className="Link">35 Overs</button>
          <div className="dropdown-content">
            <Link to="/35Overs/ShaheenMavericks">Shaheen Mavericks</Link>
            <Link to="/35Overs/ShaheenGladiators">Shaheen Gladiators</Link>
            <Link to="/35Overs/ShaheenWarriors">Shaheen Warriors</Link>
            <Link to="/35Overs/ShaheenKnights">Shaheen Knights</Link>
            <Link to="/35Overs/ShaheenTitans">Shaheen Titans</Link>
          </div>
        </div>
        <div className="dropdown">
          <button className="Link">T20</button>
          <div className="dropdown-content">
            <Link to="/T20/ShaheenMavericks">Shaheen Mavericks</Link>
            <Link to="/T20/ShaheenGladiators">Shaheen Gladiators</Link>
            <Link to="/T20/ShaheenWarriors">Shaheen Warriors</Link>
            <Link to="/T20/ShaheenKnights">Shaheen Knights</Link>
          </div>
        </div>
        <div className="dropdown">
          <button className="Link">Weeknight</button>
          <div className="dropdown-content">
            <Link to="/WeekNights/ShaheenMavericks">Shaheen Mavericks</Link>
            <Link to="/WeekNights/ShaheenGladiators">Shaheen Gladiators</Link>
            <Link to="/WeekNights/ShaheenWarriors">Shaheen Warriors</Link>
          </div>
        </div>
        <Link className="Link" to="/OverAll/OverAll">
          Overall Records
        </Link>
        <a className="Link" href="/#schedule" onClick={handleScheduleClick}>
          Schedule
        </a>
        <Link className="Link" to="/subscribe">
          Reminders
        </Link>
        <button className="nav-btn nav-close-btn" onClick={showNavbar}>
          <FaTimes />
        </button>
      </nav>
      <button className="nav-btn" onClick={showNavbar}>
        <FaBars />
      </button>
    </header>
  );
}

export default Navbar;
